import produce from 'immer'
import { actions } from './actions'

const initialState = {
  bibliotecasPreguntas: {
    data: [],
    loading: false,
    error: '',
  },
  bibliotecaPreguntas: {
    data: null,
    loading: false,
    error: '',
  },
  bibliotecasPreguntasByProducto: {
    data: [],
    loading: false,
    error: '',
  },
}

export default function bibPreguntaReducer(state = initialState, action) {
  switch (action.type) {
    case actions.BIBLIOTECAS_PREGUNTAS_LOAD_REQUESTED:
      return {
        ...state,
        bibliotecasPreguntas: { ...state.bibliotecasPreguntas, data: null, loading: true },
      }
    case actions.BIBLIOTECAS_PREGUNTAS_LOAD_SUCCEEDED:
      return {
        ...state,
        bibliotecasPreguntas: {
          ...state.bibliotecasPreguntas,
          data: action.payload,
          loading: false,
          reload: false,
        },
      }
    case actions.BIBLIOTECAS_PREGUNTAS_LOAD_FAILED:
      return {
        ...state,
        bibliotecasPreguntas: {
          ...state.bibliotecasPreguntas,
          loading: false,
          error: action.error,
        },
      }
    case actions.BIBLIOTECAS_PREGUNTAS_FILTERED_LOAD_REQUESTED:
      return {
        ...state,
        bibliotecasPreguntas: { ...state.bibliotecasPreguntas, data: null, loading: true },
      }
    case actions.BIBLIOTECAS_PREGUNTAS_FILTERED_LOAD_SUCCEEDED:
      return {
        ...state,
        bibliotecasPreguntas: {
          ...state.bibliotecasPreguntas,
          data: action.payload,
          loading: false,
          reload: false,
        },
      }
    case actions.BIBLIOTECAS_PREGUNTAS_FILTERED_LOAD_FAILED:
      return {
        ...state,
        bibliotecasPreguntas: {
          ...state.bibliotecasPreguntas,
          loading: false,
          error: action.error,
        },
      }
    case actions.BIBLIOTECA_PREGUNTA_DELETE_REQUESTED:
      return {
        ...state,
        bibliotecasPreguntas: { ...state.bibliotecasPreguntas, loading: true },
      }
    case actions.BIBLIOTECA_PREGUNTA_DELETE_SUCCEEDED:
      return {
        ...state,
        bibliotecasPreguntas: {
          ...state.bibliotecasPreguntas,
          data: state.bibliotecasPreguntas.data.filter(
            bibPregunta => bibPregunta.id !== action.payload,
          ),
          loading: false,
        },
      }
    case actions.BIBLIOTECA_PREGUNTA_DELETE_FAILED:
      return {
        ...state,
        bibliotecasPreguntas: {
          ...state.bibliotecasPreguntas,
          loading: false,
          error: action.error,
        },
      }
    case actions.BIBLIOTECA_PREGUNTA_CREATE_REQUESTED:
      return {
        ...state,
        bibliotecasPreguntas: { ...state.bibliotecasPreguntas, loading: true },
      }
    case actions.BIBLIOTECA_PREGUNTA_CREATE_SUCCEEDED:
      return {
        ...state,
        bibliotecasPreguntas: {
          ...state.bibliotecasPreguntas,
          data: [...state.bibliotecasPreguntas.data, action.payload],
          loading: false,
        },
      }
    case actions.BIBLIOTECA_PREGUNTA_CREATE_FAILED:
      return {
        ...state,
        bibliotecasPreguntas: {
          ...state.bibliotecasPreguntas,
          loading: false,
          error: action.error,
        },
      }
    case actions.BIBLIOTECA_PREGUNTA_UPDATE_REQUESTED:
      return {
        ...state,
        bibliotecaPreguntas: { ...state.bibliotecasPreguntas, loading: true },
      }
    case actions.BIBLIOTECA_PREGUNTA_UPDATE_SUCCEEDED:
      return {
        ...state,
        bibliotecaPreguntas: {
          ...state.bibliotecaPreguntas,
          data: action.payload,
          loading: false,
        },
      }
    case actions.BIBLIOTECA_PREGUNTA_UPDATE_FAILED:
      return {
        ...state,
        bibliotecaPreguntas: {
          ...state.bibliotecasPreguntas,
          loading: false,
          error: action.error,
        },
      }
    case actions.BIBLIOTECA_PREGUNTA_LOAD_BY_ID_REQUESTED:
      return {
        ...state,
        bibliotecaPreguntas: { ...state.bibliotecaPreguntas, data: null, loading: true },
      }
    case actions.BIBLIOTECA_PREGUNTA_LOAD_BY_ID_SUCCEEDED:
      return {
        ...state,
        bibliotecaPreguntas: {
          ...state.bibliotecaPreguntas,
          data: action.payload,
          loading: false,
        },
      }
    case actions.BIBLIOTECA_PREGUNTA_LOAD_BY_ID_FAILED:
      return {
        ...state,
        bibliotecaPreguntas: {
          ...state.bibliotecaPreguntas,
          loading: false,
          error: action.error,
        },
      }
    case actions.BIBLIOTECA_PREGUNTA_SET_PIJAMA_SUCCEEDED: {
      const { id, activado } = action.payload
      const newState = produce(state, draftState => {
        const pregunta = draftState.bibliotecasPreguntas?.data?.find(p => p.id === id)
        if (pregunta) pregunta.esPijama = activado
      })

      return newState
    }
    case actions.BIBLIOTECA_PREGUNTA_SET_REPETIRBYQUANTITY_SUCCEEDED: {
      const { id, activado } = action.payload
      const newState = produce(state, draftState => {
        const pregunta = draftState.bibliotecasPreguntas?.data?.find(p => p.id === id)
        if (pregunta) pregunta.repetirByQuantity = activado
      })

      return newState
    }
    case actions.PREGUNTA_BIBLIOTECA_DELETED_STATE_CHANGED: {
      const { idPregunta, eliminada } = action.payload
      const newState = produce(state, draftState => {
        const pregunta = draftState.bibliotecaPreguntas?.data?.preguntas?.find(
          p => p.id === idPregunta,
        )
        if (pregunta) pregunta.eliminada = eliminada
      })

      return newState
    }
    case actions.PREGUNTA_BIBLIOTECA_EDITED: {
      const preguntaEditada = action.payload
      preguntaEditada.preguntasHijas = null
      const newState = produce(state, draftState => {
        const preguntas = draftState.bibliotecaPreguntas?.data?.preguntas
        if (preguntas) {
          const preguntasEdited = preguntas.map(p => {
            if (p.id === preguntaEditada.id) {
              return preguntaEditada
            }
            return p
          })
          const preguntasSorted = preguntasEdited.sort((a, b) => a.orden - b.orden)
          draftState.bibliotecaPreguntas.data.preguntas = preguntasSorted
        }
      })
      return newState
    }
    case actions.PREGUNTA_BIBLIOTECA_CREATED: {
      const preguntaCreada = action.payload
      const newState = produce(state, draftState => {
        const preguntas = draftState.bibliotecaPreguntas?.data?.preguntas
        if (preguntas) {
          const preguntasAdded = preguntas.concat(preguntaCreada)
          const preguntasSorted = preguntasAdded.sort((a, b) => a.orden - b.orden)
          draftState.bibliotecaPreguntas.data.preguntas = preguntasSorted
        } else {
          draftState.bibliotecaPreguntas.data.preguntas = [preguntaCreada]
        }
      })
      return newState
    }
    case actions.OPCION_PREGUNTA_EDITED: {
      const opcionEditada = action.payload
      const newState = produce(state, draftState => {
        const opciones = draftState.bibliotecaPreguntas?.data?.preguntas?.find(
          p => p.id === opcionEditada.preguntaId,
        )?.opciones
        if (opciones) {
          const opcionesEdited = opciones.map(o => {
            if (o.id === opcionEditada.id) {
              return opcionEditada
            }
            return o
          })
          const opcionesSorted = opcionesEdited.sort((a, b) => a.orden - b.orden)

          draftState.bibliotecaPreguntas.data.preguntas.find(
            p => p.id === opcionEditada.preguntaId,
          ).opciones = opcionesSorted
        }
      })
      return newState
    }
    case actions.OPCION_PREGUNTA_CREATED: {
      const opcionCreada = action.payload
      const newState = produce(state, draftState => {
        const opciones = draftState.bibliotecaPreguntas?.data?.preguntas?.find(
          p => p.id === opcionCreada.preguntaId,
        )?.opciones
        if (opciones) {
          const opcionesAdded = opciones.concat(opcionCreada)
          const opcionesSorted = opcionesAdded.sort((a, b) => a.orden - b.orden)
          draftState.bibliotecaPreguntas.data.preguntas.find(
            p => p.id === opcionCreada.preguntaId,
          ).opciones = opcionesSorted
        } else {
          draftState.bibliotecaPreguntas.data.preguntas.find(
            p => p.id === opcionCreada.preguntaId,
          ).opciones = [opcionCreada]
        }
      })
      return newState
    }
    case actions.ASIGNAR_OPCIONES_PREGUNTA: {
      const {
        opcionesSeleccionadas,
        opcionPadreId,
        preguntaActualId,
        preguntaPadreId,
      } = action.payload
      const newState = produce(state, draftState => {
        const preguntaActual = draftState.bibliotecaPreguntas?.data?.preguntas?.find(
          p => p.id === preguntaActualId,
        )
        if (!preguntaActual) return

        const opciones = preguntaActual?.opciones

        if (!opciones) return

        draftState.bibliotecaPreguntas.data.preguntas.find(
          p => p.id === preguntaActualId,
        ).preguntaPadreId = preguntaPadreId

        draftState.bibliotecaPreguntas.data.preguntas.find(
          p => p.id === preguntaActualId,
        ).opcionPadreId = opcionPadreId

        draftState.bibliotecaPreguntas.data.preguntas.find(
          p => p.id === preguntaActualId,
        ).opciones = opciones.map(o => {
          if (opcionesSeleccionadas.map(os => os.id).includes(o.id)) {
            return { ...o, opcionPadreId }
          }
          return o
        })
      })
      return newState
    }
    case actions.BIBLIOTECA_PREGUNTA_BY_PRODUCTO_ID_REQUESTED:
      return {
        ...state,
        bibliotecasPreguntasByProducto: {
          ...state.bibliotecasPreguntasByProducto,
          data: null,
          loading: true,
        },
      }
    case actions.BIBLIOTECA_PREGUNTA_BY_PRODUCTO_ID_SUCCEEDED:
      return {
        ...state,
        bibliotecasPreguntasByProducto: {
          ...state.bibliotecasPreguntasByProducto,
          data: action.payload,
          loading: false,
          reload: false,
        },
      }
    case actions.BIBLIOTECA_PREGUNTA_BY_PRODUCTO_ID_FAILED:
      return {
        ...state,
        bibliotecasPreguntasByProducto: {
          ...state.bibliotecasPreguntasByProducto,
          loading: false,
          error: action.error,
        },
      }
    case actions.BIBLIOTECA_PREGUNTA_PRODUCTO_UPDATE_REQUESTED:
      return {
        ...state,
        bibliotecasPreguntasByProducto: {
          ...state.bibliotecasPreguntasByProducto,
          loading: true,
          error: '',
        },
      }
    case actions.BIBLIOTECA_PREGUNTA_PRODUCTO_UPDATE_SUCCEEDED:
      return {
        ...state,
        bibliotecasPreguntasByProducto: {
          ...state.bibliotecasPreguntasByProducto,
          data: [...action.payload],
          loading: false,
          error: '',
        },
      }
    case actions.BIBLIOTECA_PREGUNTA_PRODUCTO_UPDATE_FAILED:
      return {
        ...state,
        bibliotecasPreguntasByProducto: {
          ...state.bibliotecasPreguntasByProducto,
          loading: false,
          error: action.error,
        },
      }
    default:
      return state
  }
}
